import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ServiceInfo from '../ServiceInfo';
import ServiceJourneyInfo from '../ServiceJourneyInfo';
import './DetailedServicePage.scss';
import { NavBar } from '../../../utility/navBar/Navbar';
import ServiceDescription from './ServiceDescription';
import DetailedServiceJourney  from './DetailedServiceJourney';
import { Contact } from '../../../utility/contact/Contact';

export const DetailedServicePage = () => {
    const { serviceId } = useParams();
    const service = ServiceInfo.find(service => service.id === parseInt(serviceId));
    const ServiceJourney = ServiceJourneyInfo.find(journey => journey.id === service.journeyId);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (!service) {
        return <div className="error">Service not found</div>;
    }

    return (
        <>
            <NavBar theme='light' />
            <ServiceDescription service={service} />
            <DetailedServiceJourney journey={ServiceJourney} />
            <Contact />
        </>
    );
};
